import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Btn, Spinner } from "@/components/kit";
import { useAdminQuery } from "@/hooks/queries";
import { adminApi } from "@/lib/api";
import { AdminHeader, AdminTable, Badge } from "@/pages/admin/AdminLayout";

export default function AdminCategories() {
  const q = useAdminQuery("/admin/categories");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (p, msg) => {
    try { await p; if (msg) toast.success(msg); q.refetch(); } catch (e) { toast.error(e.message); }
  };
  const create = async () => {
    if (!name.trim()) return;
    setBusy(true);
    await run(adminApi.post("/admin/categories", { name: name.trim() }), "Category added.");
    setName("");
    setBusy(false);
  };
  return (
    <>
      <AdminHeader title="Categories" sub="Business categories used for contacts and user profiles." />
      <div className="flex gap-3 mb-4 max-w-lg">
        <input className="t-input bg-white" placeholder="New category name" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && create()} data-testid="admin-category-name" />
        <Btn onClick={create} loading={busy} testid="admin-category-add"><Plus className="w-5 h-5" />Add</Btn>
      </div>
      {q.isLoading ? <Spinner /> : (
        <AdminTable testid="admin-categories-table" rows={q.data ?? []} cols={[
          { label: "Order", k: "sortOrder" }, { label: "Name", render: (c) => <b>{c.name}</b> }, { label: "Slug", k: "slug" }, { label: "Contacts", k: "count" },
          { label: "Status", render: (c) => <Badge tone={c.status === "active" ? "success" : "neutral"}>{c.status}</Badge> },
          { label: "Active", render: (c) => <Switch checked={c.status === "active"} onCheckedChange={() => run(adminApi.patch(`/admin/categories/${c.id}`, { status: c.status === "active" ? "inactive" : "active" }))} data-testid={`admin-category-toggle-${c.id}`} /> },
          { label: "", render: (c) => <button className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-[#FEF2F2]" onClick={() => window.confirm(`Delete "${c.name}"?`) && run(adminApi.del(`/admin/categories/${c.id}`), "Category deleted.")} data-testid={`admin-category-delete-${c.id}`}><Trash2 className="w-4 h-4 text-[#DC2626]" /></button> },
        ]} />
      )}
    </>
  );
}
